module.exports = __webpack_public_path__ + "static/avainapteekit-82b29f061d6ee2c28314a545a1b04a7e.svg";